import { useTranslation } from 'react-i18next';
import type { IPathFormProps } from './IPathFormProps';

/**
 * Форма шляху під рядком (прототип v4 pathFormLabel / pathName): «Новий дочірній вузол «X»» чи «Перейменувати «X»», назва (Enter —
 * зберегти, Escape — скасувати), для ітерацій — дати початку й кінця; «Зберегти» і «Скасувати».
 */
export function PathForm({ node, depth, kind, editor }: IPathFormProps) {
  const { t } = useTranslation();
  const e = editor.edit;
  if (!e) return null;
  return (
    <div className="cu-pathform" style={{ paddingLeft: depth * 24 + 40 }}>
      <span className="sp-muted cu-pathform__label">{t(e.mode === 'add' ? 'sysCust.paths.newChildOf' : 'sysCust.paths.renameOf', { name: node.name })}</span>
      <input className="sp-input cu-pathform__name" autoFocus value={e.name} placeholder={t('sysCust.paths.name')} aria-label={t('sysCust.paths.name')}
        onChange={(ev) => editor.change({ name: ev.target.value })}
        onKeyDown={(ev) => { if (ev.key === 'Enter') { ev.preventDefault(); editor.save(); } if (ev.key === 'Escape') editor.cancel(); }} />
      {kind === 'iterations' && (
        <>
          <input type="date" className="sp-input cu-pathform__date" value={e.start} aria-label={t('sysCust.paths.start')} onChange={(ev) => editor.change({ start: ev.target.value })} />
          <span className="sp-muted">–</span>
          <input type="date" className="sp-input cu-pathform__date" value={e.end} aria-label={t('sysCust.paths.end')} onChange={(ev) => editor.change({ end: ev.target.value })} />
        </>
      )}
      <button type="button" className="sp-btn sp-btn--primary cu-pathform__btn" onClick={editor.save}>{t('sysCust.paths.save')}</button>
      <button type="button" className="sp-btn cu-pathform__btn" onClick={editor.cancel}>{t('sysCust.paths.cancel')}</button>
    </div>
  );
}
